/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContentEditorQuestionCataloguesQuestionCatalogueCategory } from './ContentEditorQuestionCataloguesQuestionCatalogueCategory';
import {
    ContentEditorQuestionCataloguesQuestionCatalogueCategoryFromJSON,
    ContentEditorQuestionCataloguesQuestionCatalogueCategoryFromJSONTyped,
    ContentEditorQuestionCataloguesQuestionCatalogueCategoryToJSON,
} from './ContentEditorQuestionCataloguesQuestionCatalogueCategory';
import type { ContentEditorQuestionCataloguesQuestionIndexResponseChoicesInner } from './ContentEditorQuestionCataloguesQuestionIndexResponseChoicesInner';
import {
    ContentEditorQuestionCataloguesQuestionIndexResponseChoicesInnerFromJSON,
    ContentEditorQuestionCataloguesQuestionIndexResponseChoicesInnerFromJSONTyped,
    ContentEditorQuestionCataloguesQuestionIndexResponseChoicesInnerToJSON,
} from './ContentEditorQuestionCataloguesQuestionIndexResponseChoicesInner';
import type { ContentEditorUploadedFileMap } from './ContentEditorUploadedFileMap';
import {
    ContentEditorUploadedFileMapFromJSON,
    ContentEditorUploadedFileMapFromJSONTyped,
    ContentEditorUploadedFileMapToJSON,
} from './ContentEditorUploadedFileMap';

/**
 * Content editor question catalogues question
 * @export
 * @interface ContentEditorQuestionCataloguesQuestionCreateResponse
 */
export interface ContentEditorQuestionCataloguesQuestionCreateResponse {
    /**
     * 
     * @type {number}
     * @memberof ContentEditorQuestionCataloguesQuestionCreateResponse
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorQuestionCataloguesQuestionCreateResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorQuestionCataloguesQuestionCreateResponse
     */
    question_type: string;
    /**
     * 
     * @type {number}
     * @memberof ContentEditorQuestionCataloguesQuestionCreateResponse
     */
    point_value: number;
    /**
     * 
     * @type {number}
     * @memberof ContentEditorQuestionCataloguesQuestionCreateResponse
     */
    tolerance: number;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorQuestionCataloguesQuestionCreateResponse
     */
    hint: string;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorQuestionCataloguesQuestionCreateResponse
     */
    response_type: string;
    /**
     * 
     * @type {Date}
     * @memberof ContentEditorQuestionCataloguesQuestionCreateResponse
     */
    created_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContentEditorQuestionCataloguesQuestionCreateResponse
     */
    updated_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContentEditorQuestionCataloguesQuestionCreateResponse
     */
    published_at: Date;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorQuestionCataloguesQuestionCreateResponse
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof ContentEditorQuestionCataloguesQuestionCreateResponse
     */
    categories_count: number;
    /**
     * 
     * @type {Array<ContentEditorQuestionCataloguesQuestionCatalogueCategory>}
     * @memberof ContentEditorQuestionCataloguesQuestionCreateResponse
     */
    question_catalogue_categories?: Array<ContentEditorQuestionCataloguesQuestionCatalogueCategory>;
    /**
     * 
     * @type {ContentEditorUploadedFileMap}
     * @memberof ContentEditorQuestionCataloguesQuestionCreateResponse
     */
    file?: ContentEditorUploadedFileMap;
    /**
     * 
     * @type {Array<ContentEditorQuestionCataloguesQuestionIndexResponseChoicesInner>}
     * @memberof ContentEditorQuestionCataloguesQuestionCreateResponse
     */
    choices?: Array<ContentEditorQuestionCataloguesQuestionIndexResponseChoicesInner>;
}

/**
 * Check if a given object implements the ContentEditorQuestionCataloguesQuestionCreateResponse interface.
 */
export function instanceOfContentEditorQuestionCataloguesQuestionCreateResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "question_type" in value;
    isInstance = isInstance && "point_value" in value;
    isInstance = isInstance && "tolerance" in value;
    isInstance = isInstance && "hint" in value;
    isInstance = isInstance && "response_type" in value;
    isInstance = isInstance && "created_at" in value;
    isInstance = isInstance && "updated_at" in value;
    isInstance = isInstance && "published_at" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "categories_count" in value;

    return isInstance;
}

export function ContentEditorQuestionCataloguesQuestionCreateResponseFromJSON(json: any): ContentEditorQuestionCataloguesQuestionCreateResponse {
    return ContentEditorQuestionCataloguesQuestionCreateResponseFromJSONTyped(json, false);
}

export function ContentEditorQuestionCataloguesQuestionCreateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentEditorQuestionCataloguesQuestionCreateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'question_type': json['question_type'],
        'point_value': json['point_value'],
        'tolerance': json['tolerance'],
        'hint': json['hint'],
        'response_type': json['response_type'],
        'created_at': (new Date(json['created_at'])),
        'updated_at': (new Date(json['updated_at'])),
        'published_at': (new Date(json['published_at'])),
        'status': json['status'],
        'categories_count': json['categories_count'],
        'question_catalogue_categories': !exists(json, 'question_catalogue_categories') ? undefined : ((json['question_catalogue_categories'] as Array<any>).map(ContentEditorQuestionCataloguesQuestionCatalogueCategoryFromJSON)),
        'file': !exists(json, 'file') ? undefined : ContentEditorUploadedFileMapFromJSON(json['file']),
        'choices': !exists(json, 'choices') ? undefined : ((json['choices'] as Array<any>).map(ContentEditorQuestionCataloguesQuestionIndexResponseChoicesInnerFromJSON)),
    };
}

export function ContentEditorQuestionCataloguesQuestionCreateResponseToJSON(value?: ContentEditorQuestionCataloguesQuestionCreateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'question_type': value.question_type,
        'point_value': value.point_value,
        'tolerance': value.tolerance,
        'hint': value.hint,
        'response_type': value.response_type,
        'created_at': (value.created_at.toISOString()),
        'updated_at': (value.updated_at.toISOString()),
        'published_at': (value.published_at.toISOString()),
        'status': value.status,
        'categories_count': value.categories_count,
        'question_catalogue_categories': value.question_catalogue_categories === undefined ? undefined : ((value.question_catalogue_categories as Array<any>).map(ContentEditorQuestionCataloguesQuestionCatalogueCategoryToJSON)),
        'file': ContentEditorUploadedFileMapToJSON(value.file),
        'choices': value.choices === undefined ? undefined : ((value.choices as Array<any>).map(ContentEditorQuestionCataloguesQuestionIndexResponseChoicesInnerToJSON)),
    };
}

